import { Customer, ScheduledFlight, Site } from '../../../../../types';
import React from 'react';
import { stylesheet } from 'typestyle';
import { Gray100, typeBase14RegularProperties, typeCompact14MediumProperties } from '@traceair/tds';
import { MissionWindowGcpGuides } from './MissionWindowGcpGuides';
import { ExistingGcpsButton } from './buttons/ExistingGcpsButton';

const css = stylesheet({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  heading: {
    margin: '0 0 12px',
    ...typeCompact14MediumProperties,
  },
  note: {
    margin: '-5px 0 16px',
    ...typeBase14RegularProperties,
    color: Gray100,
  },
  button: {
    marginTop: -8,
    maxWidth: 230,
  },
});

interface Props {
  customer: Customer;
  site: Site;
  schedule?: ScheduledFlight;
}

export const MissionWindowGcpMaintenance = ({ customer, site, schedule }: Props) => {
  if (!schedule?.contractContainsRfmm) {
    return null;
  }

  return (
    <div className={css.container}>
      <div>
        <div className={css.heading}>Regular Flight Marker Maintenance (rFMM)</div>
        <div className={css.note}>
          This site requires regular flight marker maintenance.
          <br /> Please check all GCPs prior to the flight.
        </div>

        <div className={css.button}>
          <ExistingGcpsButton customer={customer} site={site} />
        </div>
      </div>

      <MissionWindowGcpGuides />
    </div>
  );
};
